import React, { FC } from 'react';
import { Field, FieldProps } from 'formik';
import { FilterValues } from '../../../shared/types';

type Props = {
  onRetainedFiltersChange: (newFilters: FilterValues) => void;
};

const FilterOverlayFormListener: FC<Props> = ({ onRetainedFiltersChange }) => {
  return (
    <Field>
      {({ form }: FieldProps<FilterValues>): void => {
        onRetainedFiltersChange(form.values);

        return null;
      }}
    </Field>
  );
};

export default FilterOverlayFormListener;
